import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref, toRefs } from 'vue';

interface Props {
  end: Date;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    end: null
  },
  setup(__props: any) {

const props = __props as {
  end: Date;
}



const { end } = toRefs(props);

const timeParts = ref([0, 0, 0]);
const countdownInterval = ref();

function pad(n: number, width: number, z?: string) {
  const val = z || '0';
  return `${n}`.length >= width
    ? `${n}`
    : `${new Array(width - `${n}`.length + 1).join(val)}${n}`;
}

function remainingTime(): string {
  if (
    timeParts.value[0] >= 0 &&
    timeParts.value[1] >= 0 &&
    timeParts.value[2] >= 0
  ) {
    return `${pad(timeParts.value[0], 2)}:${pad(timeParts.value[1], 2)}:${pad(
      timeParts.value[2],
      2
    )}`;
  }
  return 'Soon';
}

onMounted(() => {
  countdownInterval.value = setInterval(() => {
    const now = new Date().valueOf();
    const distance = new Date(end.value).valueOf() - now;

    const seconds = Math.floor((distance / 1000) % 60);
    const minutes = Math.floor((distance / 1000 / 60) % 60);
    const hours = Math.floor(distance / (1000 * 60 * 60));
    timeParts.value[0] = hours;
    timeParts.value[1] = minutes;
    timeParts.value[2] = seconds;
  }, 1000);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, _toDisplayString(remainingTime()), 1))
}
}

})